import { get, put,Delete,post } from '../axios'

// 电能质量管理-列表
export const qualityList = params => get(`/web/electric/quality/list`,params);


